import axios from "../axios/axios";
import React, { useContext, useEffect, useRef, useState } from "react";
import Context from "../../Context/Context";

import "../../styles/metas.css";
import "../../styles/metas.css";
import NotificacaoDeErro from "../Notificacao/NotificacaDeErro";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
pdfMake.vfs = pdfFonts.vfs;

function MetasAdministrador() {
  const [metas, setMetas] = useState();
  const { usuario } = useContext(Context);
  const [meta, setMeta] = useState(null);
  const metaIndividual = useRef();
  const metaEquipe = useRef();
  const [pagina, setPagina] = useState("metas");
  const [registros, setRegistros] = useState({});
  const [mesSelecionado, setMesSelecionado] = useState("");
  const [anoSelecionado, setAnoSelecionado] = useState("");
  const [mostrarNotificacaoDeErro, setMostarNotificacaoDeErro] =
    useState(false);
  const [msn, setMsn] = useState("");

  const getMetas = async () => {
    try {
      const { data } = await axios.get("/indicacao/metas/admin", {
        headers: { Authorization: usuario.token },
      });
      setMetas(data);
    } catch (error) {
      setMsn(error);
      setMostarNotificacaoDeErro(true);
    }
  };
  const getRegistrosMetas = async () => {
    try {
      const { data } = await axios.get("/indicacao/metas/registros", {
        headers: { Authorization: usuario.token },
      });
      setRegistros(data);
    } catch (error) {
      setMsn(error);
      setMostarNotificacaoDeErro(error);
    }
  };
  // const exportarPdf = async (data) => {
  //  const { data: registrosPdf } = await axios.get('http://localhost:3001/indicacao/metas/registros/pdf', {
  //      headers: { Authorization: usuario.token }
  //  })
  //  const byteArr = new Uint8Array(Object.values(registrosPdf))
  //  const blob = new Blob([byteArr], { type: 'application/pdf'})
  //  const link = document.createElement('a')
  //  link.href = URL.createObjectURL(blob)
  //  link.download = 'registros.pdf' // registros-mes-ano.pdf
  //  link.click()
  // }
  const toBase64 = (url) => {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.crossOrigin = "anonymous";
      img.onload = () => {
        const canvas = document.createElement("canvas");
        canvas.width = img.width;
        canvas.height = img.height;
        const ctx = canvas.getContext("2d");
        ctx.drawImage(img, 0, 0);
        const dataURL = canvas.toDataURL("image/"); // ou 'image/jpeg' se for JPG
        resolve(dataURL);
      };
      img.onerror = reject;
      img.src = url;
    });
  };

  const gerarPDFComTabela = async (registros) => {
    const logoBase64 = await toBase64("/logo2.png"); // caminho relativo a /public
    const logoBase64_2 = await toBase64("/logo3.png");

    const formatedData = registros.map(
      ({
        usuario,
        ano,
        meta_equipe,
        meta_individual,
        soma_imediatas,
        soma_mediatas,
        total,
      }) => [
        usuario.nome,
        usuario.celula_id === 6 ? "Mediata" : "Imediata",
        soma_mediatas,
        soma_imediatas,
        total,
        meta_individual,
        meta_equipe,
        ano,
      ],
    );

    const docDefinition = {
      pageSize: "A4",
      pageMargins: [56.7, 56.7, 56.7, 56.7],

      background: () => [
        {
          image: logoBase64_2,
          width: 200,
          opacity: 0.05,
          absolutePosition: { x: 197.64, y: 300 },
        },
      ],

      header: (currentPage, pageCount, pageSize) => {
        return {
          margin: [0, 0, 0, 0],
          columns: [
            {
              width: "*",
              text: "",
            },
            {
              width: "auto",
              image: logoBase64,
              width: 150,
              alignment: "center",
            },
            {
              width: "*",
              text: "",
            },
          ],
        };
      },

      footer: function (currentPage, pageCount) {
        return {
          margin: [40, 0, 40, 30],
          columns: [
            // Coluna esquerda com ícones e contatos
            {
              width: "33%",
              stack: [
                {
                  text: "📞 (11) 3230-1126",
                  margin: [0, 2, 0, 0],
                  fontSize: 9,
                },
                {
                  text: "✉️ contato@alfaleiloes.com",
                  margin: [0, 2, 0, 0],
                  fontSize: 9,
                },
                {
                  text: "🌐 www.alfaleiloes.com",
                  margin: [0, 2, 0, 0],
                  fontSize: 9,
                },
              ],
              alignment: "left",
              margin: [0, 10, 0, 0],
            },

            // Coluna do meio com endereço
            {
              width: "34%",
              text: "📍 Rua Curupacê, nº 260 - Mooca,\nCEP 03120-010 - São Paulo - SP",
              alignment: "center",
              fontSize: 9,
              margin: [0, 25, 0, 0],
            },

            // Coluna direita com QR Code e ícones sociais (se desejar adicionar imagens, pode fazer isso com 'image')
            {
              width: "33%",
              stack: [
                {
                  qr: "https://www.alfaleiloes.com.br",
                  fit: 50,
                  alignment: "right",
                },
              ],
            },
          ],
        };
      },

      content: [
        {
          text: "Relatório de Metas dos Usuários",
          style: "titulo",
        },
        {
          style: "tabela",
          table: {
            headerRows: 1,
            widths: [
              "auto",
              "*",
              "auto",
              "auto",
              "auto",
              "auto",
              "auto",
              "auto",
            ],
            body: [
              [
                { text: "Nome", style: "tableHeader" },
                { text: "Célula", style: "tableHeader" },
                { text: "Soma Mediatas", style: "tableHeader" },
                { text: "Soma Imediatas", style: "tableHeader" },
                { text: "Total", style: "tableHeader" },
                { text: "Meta Individual", style: "tableHeader" },
                { text: "Meta Equipe", style: "tableHeader" },
                { text: "Ano", style: "tableHeader" },
              ],
              ...formatedData,
            ],
          },
          layout: {
            fillColor: (rowIndex) => (rowIndex === 0 ? "#050505" : null),
            hLineColor: () => "#ccc",
            vLineColor: () => "#ccc",
            paddingLeft: () => 8,
            paddingRight: () => 8,
            paddingTop: () => 3,
            paddingBottom: () => 3,
          },
        },
      ],

      styles: {
        titulo: {
          fontSize: 14,
          bold: true,
          alignment: "center",
          margin: [0, 20, 0, 10],
        },
        tableHeader: {
          bold: true,
          color: "white",
          fillColor: "#000000",
          fontSize: 10,
          alignment: "center",
        },
        tabela: {
          margin: [0, 10, 0, 0],
        },
      },

      defaultStyle: {
        fontSize: 10,
      },
    };

    pdfMake.createPdf(docDefinition).download("relatorio-alfa-leiloes.pdf");
  };
  const meses = {
    1: "Janeiro",
    2: "Fevereiro",
    3: "Março",
    4: "Abril",
    5: "Maio",
    6: "Junho",
    7: "Julho",
    8: "Agosto",
    9: "Setembro",
    10: "Outubro",
    11: "Novembro",
    12: "Dezembro",
  };
  useEffect(() => {
    getMetas();
  }, []);
  useEffect(() => {
    if (pagina != "metas") {
      getRegistrosMetas();
    }
  }, [pagina]);
  const handleCloseModal = () => {
    setMeta(null);
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    const data = {
      usuarioId: meta.id,
      metaEquipe: +metaEquipe.current.value,
      metaIndividual: +metaIndividual.current.value,
      celula: meta.celula,
    };
    try {
      await axios.post("/indicacao/metas/editar", data, {
        headers: {
          Authorization: usuario.token,
        },
      });
      metaEquipe.current.value = "";
      metaIndividual.current.value = "";
      getMetas();
      setMeta(null);
    } catch (error) {
      setMsn(error);
      setMostarNotificacaoDeErro(true);
    }
  };
  return (
    <div>
      <div className="cont-metas">
        <button onClick={() => setPagina("metas")}>Metas dos usuários</button>
        <button onClick={() => setPagina("registro")}>
          Registro Mensais das Metas
        </button>
      </div>
      {pagina == "metas" && (
        <>
          <table className="tabela-metas">
            <thead>
              <tr>
                <th>Nome</th>
                <th>Meta Individual</th>
                <th>Meta Equipe</th>
                <th>Editor</th>
              </tr>
            </thead>
            <tbody>
              {metas?.map((e) => (
                <tr className="text-center" key={e.id}>
                  <td>{e.nome}</td>
                  <td>{e.meta_individual}</td>
                  <td>{e.meta_equipe}</td>
                  <td>
                    <button
                      className="bg-gray-400 text-white py-1 px-4"
                      onClick={() => setMeta(e)}
                    >
                      Editar
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          {meta && (
            <div className="modal-overlay" onClick={handleCloseModal}>
              <div
                className="edit-captacao-modal"
                onClick={(e) => e.stopPropagation()}
              >
                <div classname="edit-captacao-modal-content">
                  {" "}
                  <h3>{`Editar Meta`}</h3>
                  <form onSubmit={handleSubmit}>
                    <label>
                      Nome:
                      <input type="text" value={meta.nome} readOnly />
                    </label>
                    <label>
                      Meta Individual:
                      <input ref={metaIndividual} type="number" />
                    </label>
                    <label>
                      Meta Equipe:
                      <input ref={metaEquipe} type="number" />
                    </label>
                    <button type="submit">SALVAR</button>
                  </form>
                </div>
              </div>
            </div>
          )}
        </>
      )}
      {pagina != "metas" && (
        <div>
          <section className="section-filters-meta">
            <select
              value={mesSelecionado}
              onChange={(e) => setMesSelecionado(e.target.value)}
              name="mes"
              id="mes"
            >
              <option value="">Selecione um mês</option>
              <option value="1">Janeiro</option>
              <option value="2">Fevereiro</option>
              <option value="3">Março</option>
              <option value="4">Abril</option>
              <option value="5">Maio</option>
              <option value="6">Junho</option>
              <option value="7">Julho</option>
              <option value="8">Agosto</option>
              <option value="9">Setembro</option>
              <option value="10">Outubro</option>
              <option value="11">Novembro</option>
              <option value="12">Dezembro</option>
            </select>
            <select
              value={anoSelecionado}
              onChange={(e) => setAnoSelecionado(e.target.value)}
              name="ano"
              id="ano"
            >
              <option value="">Selecione um ano aqui</option>
              <option value="2025">2025</option>
              <option value="2026">2026</option>
            </select>
          </section>
          {Object.keys(registros)
            .filter((registro) => {
              if (!registro?.split("-")[0].includes(mesSelecionado)) {
                return false;
              }
              if (!registro?.split("-")[1].includes(anoSelecionado)) {
                return false;
              }
              return true;
            })
            .map((mes) => (
              <div>
                <div className="header-metas">
                  <p>{meses[mes.split("-")[0]]}</p>
                  <button onClick={() => gerarPDFComTabela(registros[mes])}>
                    Exportar
                  </button>
                </div>
                <table className="table-metas">
                  <thead>
                    <tr>
                      <th>Nome</th>
                      <th>Celula</th>
                      <th>Soma Mediatas</th>
                      <th>Soma Imediatas</th>
                      <th>Total</th>
                      <th>Meta Individual</th>
                      <th>Meta Equipe</th>
                      <th>Ano</th>
                    </tr>
                  </thead>
                  <tbody>
                    {registros[mes].map((e) => (
                      <tr key={e.usuario_id + mes}>
                        <td>{e.usuario.nome}</td>
                        <td>
                          {e.usuario.celula_id == 6 ? "Mediata" : "Imediata"}
                        </td>
                        <td>{e.soma_mediatas}</td>
                        <td>{e.soma_imediatas}</td>
                        <td>{e.total}</td>
                        <td>{e.meta_individual}</td>
                        <td>{e.meta_equipe}</td>
                        <td>{e.ano}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            ))}
        </div>
      )}
    </div>
  );
}
export default MetasAdministrador;
